import gql from "graphql-tag";

export const setUserOnboardingEventCompleted = gql`
  mutation SetUserOnboardingEventCompleted($input: SetUserOnboardingEventCompletedRequestInput) {
    SetUserOnboardingEventCompleted(input: $input) {
      success
    }
  }
`;
